import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { MealBranchStatus } from '../enums/MealBranchStatus'

export class MealBranchEntity {
  id?: string
  branchId?: number
  branch?: {
    id?: number
    name?: string | null
    location?: LngLatEntity
    brandImage?: string | null
  }
  commission?: number

  status?: MealBranchStatus
  estimatedItemsPreparationTime?: string | null
  itemsPreparedAt?: string | null
  createdAt?: string
}
